var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bpm)?_c('span',[_vm._v("\n  "+_vm._s(_vm.bpm)+" "+_vm._s(_vm.$t('product.bpm'))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }